export const userInfo = state => state.userInfo // 用户信息

export const shopCar = state => state.shopCar // 购物车

export const searchWord = state => state.searchText // 搜索词

export const shoCartCount = state => state.shoCartCount // 观察购物车数量变化

export const getLogin = state => state.login



// WEBPACK FOOTER //
// ./src/store/getters.js